import React from "react";
import { useState,useEffect } from "react";
import SalespersonSidebar from "./SalespersonSidebar";
import './classes/ViewTab.css';
import './classes/EditSortflag.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
 import Loading from './Loading';

const EditSortflag = ({tid,detailedview}) =>{
    const [isLoading, setIsLoading] = useState(false);

 
    const [toggle, setToggle] = useState(2);
    const [errors, setErrors] = useState('');
    const[success,setSuccess] = useState('');
    const [isVisible, setIsVisible] = useState(true);
    const handleClick = () => {
        setIsVisible(!isVisible);
    };

      const location  = useLocation();
      const drupal_uid = localStorage.getItem('drupal_uid');
      const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
       var loggedin_domain = drupal_domain_url;
      if(localStorage.getItem('loggedin_domain')) {
        loggedin_domain = localStorage.getItem('loggedin_domain');
      } 
      var {id} = useParams();
     
     
      const {tab} = useParams();
      
      const loggedin_uid = localStorage.getItem('uid');
      const navigate = useNavigate();

        const app_url = configData.APP_URL;
      
        const domain_url = configData.DOMAIN_URL;
        
const initialFormData = {
  tid:tid,
  name: "",
  field_sortflag_archive: false,
  status: true,
};
const [formData, setFormData] = useState(initialFormData);

   useEffect(() => {
          setFormData({
          tid:tid,
      name: detailedview.name,
    field_sortflag_archive: detailedview.field_sortflag_archive_value,
    status:detailedview.published
    });
         }, []);
  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const validateForm = (data) => {
  let errors = "";

  if (!data.name || data.name.trim() === "") {
    errors = "Name is required.";
  }

  return errors;
};
 const inputStyle = {
  name: {
    border: errors ? '2px solid red' : '1px solid #777'
  },
 };
 const handleSubmit = async (e) => {
  e.preventDefault();
  const validationErrors = validateForm(formData);

  if (validationErrors) {
    setErrors(validationErrors);
    return;
  }

 const response = await fetch(app_url+'sortflag/admineditsortflag', {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json',
      },
      });
      const data = await response.json();
      if(data.data.msg === "Success") {
      navigate("/sortflags", {state: { message: 'Successfully updated'}});
      setSuccess(data.data.result);
      setErrors('');      
      } else {
        setErrors(data.data.result);
        setSuccess(''); 
      }
};
const handleDelete = async () => {
  if (window.confirm("Are you sure you want to delete?")) {
   const response = await fetch(app_url+'sortflag/admindeletesortflag', {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json',
      },
      });
      const data = await response.json();
      if(data.data.msg === "Success") {
      navigate("/sortflags", {state: { message: 'Deleted successfully'}});
      
      } else {
       
      }
  }
};

    return(
        <>
         {isLoading ? (
              <Loading />
            ) : (
       
            <div>
                                      {/* {errors.length > 0 && (
          <div className="set-message-error" style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`}}>
           {errors.map((item, index) => {
           return <>{item}<br /></>
          
        })}  
          </div>
        )} */}
                {success && (
                  <div className="set-message-done">
                    <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {success}
                  </div>
                )}
                {errors &&                         
                  <div className="set-message-error" style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`, padding: "10px 10px 10px 40px"}}>
                    {errors} 
                  </div>
                }
                <div className="sortflagedit-container">
                  <form onSubmit={handleSubmit}>
                    <div className="form-item name-field">
                        <label htmlFor="edit-name">
                        Name <span className="form-required" title="This field is required.">*</span>
                        </label>
                        <input
                        type="text"
                        id="edit-name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        size="60"
                        maxLength="255"
                        className="form-text required" 
                        style={inputStyle.name}                       
                        />


                    </div>

                    <div className="" id="edit-field-sortflag-archive">                    
                        <div className="form-item">
                        <input
                            type="checkbox"
                            id="edit-field-sortflag-archive"
                            name="field_sortflag_archive"
                            checked={formData.field_sortflag_archive}
                            onChange={handleChange}
                            className="form-checkbox"
                        />
                        <label className="option" htmlFor="edit-field-sortflag-archive">
                            Archive
                        </label>
                        </div>
                     </div>

                    <fieldset style={{border:0,padding:0}}className="" id="edit-status">
                        <legend>
                        <span className="publish-option">
                            <span className="fieldset-title" onClick={handleClick} style={{color:"#0074bd", cursor:"pointer"}}>
                                <span style={{ color: "black", fontSize: "8px",marginRight:"2px",marginBottom:"40px" }}>{isVisible ? '▼ ' : '▶ '}</span>
                             Publishing options
                            </span>
                        </span>
                        </legend>
                        {isVisible &&
                        <div className="fieldset-wrapper">
                        <div className="form-item">
                            <input
                            type="checkbox"
                            id="edit-status"
                            name="status"
                            checked={formData.status}
                            onChange={handleChange}
                            className="form-checkbox"
                            />
                            <label className="option" htmlFor="edit-status">Published</label>
                            <div className="description">
                            Only privileged users are allowed to view a taxonomy term if this option is disabled
                            </div>
                        </div>
                        </div>
                        }
                    </fieldset>

                    <div className="form-actions" id="edit-actions">
                        <button type="submit" className="form-submit" id="edit-submit">
                        Save
                        </button>
                        <button type="button" className="form-submit" id="edit-delete" onClick={handleDelete} style={{marginLeft:"8px"}}>
                        Delete
                        </button>
                    </div>
                </form>
             </div>
                     
            </div>
           
            )}
            </>
    );
};
export default EditSortflag;